export const locales = ['vi', 'en'] as const
export type Locale = (typeof locales)[number]
export const defaultLocale: Locale = 'vi'
export const LOCALE_COOKIE = 'locale'

export const isLocale = (value: unknown): value is Locale => locales.includes(value as Locale)

/** Intl/BCP47 tag per locale, used by the date and number formatters. */
export const intlTag: Record<Locale, string> = { vi: 'vi-VN', en: 'en-GB' }
